import React from 'react';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { ArrowDown, ArrowUp, LegendWrapper, PlacementOptions } from './Legend.styles';

type DirectionOptions = 'pointUp' | 'pointDown';

interface Props {
  percentage: number;
  direction?: DirectionOptions;
  placement?: PlacementOptions;
}

export const Legend: React.FC<Props> = ({
  percentage,
  direction = 'pointDown',
  placement = 'top',
  children,
}) => {
  return (
    <LegendWrapper percentage={percentage} placement={placement}>
      <Box
        display="flex"
        alignItems="center"
        flexDirection={percentage > 50 ? 'row-reverse' : 'row'}
        gridGap="8"
      >
        {direction === 'pointDown' ? <ArrowDown /> : <ArrowUp />}

        <Text fontSize="small" color="neutral.600" fontWeight={500}>
          {children}
        </Text>
      </Box>
    </LegendWrapper>
  );
};
